import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { DragDropContext } from 'react-beautiful-dnd';
import SubGroups from './SubGroups';
import TreeNode from '../tree/TreeNode';
import TableContext from '../../TableContext';
const SubGroup = observer(function SubGroup(props) {
    const { treeNodeRenderer, treeNodeSuffix, childrenRecords, onDragEnd, ...rest } = props;
    const { tableStore } = useContext(TableContext);
    const treeNode = (React.createElement(TreeNode, Object.assign({}, rest, { isLeaf: false, renderer: treeNodeRenderer, suffix: treeNodeSuffix }),
        React.createElement(SubGroups, { records: childrenRecords, onDragEnd: onDragEnd, treeNodeRenderer: treeNodeRenderer, treeNodeSuffix: treeNodeSuffix })));
    return tableStore.columnDraggable ? (React.createElement(DragDropContext, { onDragEnd: onDragEnd }, treeNode)) : treeNode;
});
SubGroup.displayName = 'SubGroup';
export default SubGroup;
